<template>
  <div class="select-pay">
    <iHeader />
    <iNav :search="false" :car-btn="false" :phone="false" :title="false" content>
      <div slot="content" class="carName">
        <div class="cn">收银台</div>
        <img style="width: 396px;" src="../../assets/buycar/step2.png">
      </div>
    </iNav>

    <div class="orderInfo">
      <img width="47" height="48" src="../../assets/buycar/com.png">
      <div class="infotext">
        <div class="info">
          <div class="line1">
            订单已生成！
            <span>请尽快完成支付。</span>
          </div>
          <div class="line2">
            请在
            <span v-if="parseInt((OrderInfo.PayInfo.OffTime || 0) / 60) > 0">{{ parseInt((OrderInfo.PayInfo.OffTime || 0) / 60) }}小时</span>
            <span v-if="parseInt((OrderInfo.PayInfo.OffTime || 0) % 60) > 0">{{ parseInt((OrderInfo.PayInfo.OffTime || 0) % 60) }}分</span>
            内完成支付, 超时后将取消订单。
          </div>
        </div>
        <div class="price">
          应付金额：
          <span>￥{{ ((parseInt(OrderInfo.PayInfo.TotalAmountPaidActual * 100) - parseInt(OrderInfo.PayInfo.TotalAmountPaid * 100)) / 100).toFixed(2) }}</span>
        </div>
      </div>
    </div>

    <div class="payInfo">
      <div class="tip">
        <span>选择以下支付方式付款</span>
        <span style="cursor: pointer;">
          <router-link
            target="_blank"
            :to="{ name: LinkTypeCode.HelpCenter, query: { activedParentKey: 3, activedKey: 32, Id: '164e7169-71a6-45e6-5079-08d811cf9ba3' } }"
          >
            支付遇到问题？
          </router-link>
        </span>
      </div>
      <div class="line" />
      <!-- 第三方支付 -->
      <div v-if="((OrderInfo.PayInfo || {}).CustomerPayModeInfo || {}).IsAllowThirdPay" class="three">
        <div
          v-if="((OrderInfo.PayInfo || {}).CustomerPayModeInfo || {}).IsAllowThirdPay"
          class="alipay"
          :class="{ checked: payWay == 'alipay' }"
          @click.stop="onChangePayWay('alipay')"
        >
          <img src="../../assets/buycar/alipay.png">
          <div class="check"><img style="left: 0;" src="../../assets/buycar/checked.png"></div>
        </div>
        <div
          v-if="((OrderInfo.PayInfo || {}).CustomerPayModeInfo || {}).IsAllowThirdPay"
          class="wxpay"
          :class="{ checked: payWay == 'wxpay' }"
          @click.stop="onChangePayWay('wxpay')"
        >
          <img src="../../assets/buycar/wxpay.png">
          <div class="check"><img style="left: 0;" src="../../assets/buycar/checked.png"></div>
        </div>
        <!-- <div class="firstpay" :class="{checked:payWay=='waitpay'}" @click.stop="onChangePayWay('waitpay')"
          v-if="((OrderInfo.PayInfo||{}).CustomerPayModeInfo||{}).IsAllowCashOnDeliveryInfo && (!OrderInfo.PayInfo.PayRecords||OrderInfo.PayInfo.PayRecords.length<=0)">
          <img src="../../assets/buycar/firstpay.png" />
          <div class="check">
            <img style="left:0" src="../../assets/buycar/checked.png" />
          </div>
        </div> -->
      </div>
      <div v-if="((OrderInfo.PayInfo || {}).CustomerPayModeInfo || {}).IsAllowThirdPay" class="line" style="margin-top: 50px; margin-bottom: 26px;" />
      <!-- 分次支付 -->
      <div v-if="((OrderInfo.PayInfo || {}).CustomerPayModeInfo || {}).IsAllowGradePay && payWay != 'waitpay'" class="splitpay">
        <van-radio-group v-model="grade" direction="horizontal">
          <van-radio name="1" checked-color="#0F6EEA">
            <template slot="default">
              分次支付
              <span style="color: #0F6EEA;">【推荐】</span>
            </template>
          </van-radio>
          <van-radio name="0" checked-color="#0F6EEA" :disabled="OrderInfo.PayInfo.PayRecords && OrderInfo.PayInfo.PayRecords.length > 0">全额支付</van-radio>
        </van-radio-group>
        <!-- 全额支付界面 -->
        <div v-if="grade == 0">
          <div class="banktip" style="margin-top: 30px;">
            <van-icon name="info-o" />
            检测到您当前支付金额过大，为避免支付失败，请采用银行转账方式付款：
          </div>
          <div class="banklist">
            <div class="bankitm">
              <img class="left" src="../../assets/buycar/jsyh.png">
              <div class="right">中国银行储蓄卡 单笔3万，单日5万，可全额支付</div>
            </div>
            <div class="bankitm">
              <img class="left" src="../../assets/buycar/zsyh.png">
              <div class="right">招商银行储蓄卡 单笔3万，单日5万，可全额支付</div>
            </div>
            <div class="bankitm">
              <img class="left" src="../../assets/buycar/yzyh.png">
              <div class="right">邮政银行储蓄卡 单笔3万，单日5万，可全额支付</div>
            </div>
          </div>
          <div class="morebank">
            <router-link
              target="_blank"
              :to="{ name: LinkTypeCode.HelpCenter, query: { activedParentKey: 3, activedKey: 32, Id: '164e7169-71a6-45e6-5079-08d811cf9ba3' } }"
            >
              查看更多
            </router-link>
          </div>
        </div>
        <!-- 分次支付界面 -->
        <div v-if="grade == 1" class="pay-split">
          <span class="title">分次支付金额：</span>
          <div v-for="(paid, i) in OrderInfo.PayInfo.PayRecords" :key="paid.Id" class="pay-split-item">
            <span>
              第
              <b>{{ i + 1 }}</b>
              次支付金额
            </span>
            <div class="pay-split-item-m">
              <div class="psimpd">¥ {{ paid.Amount }}</div>
              <van-button disabled>支付成功</van-button>
            </div>
          </div>
          <div v-for="(paid, i) in OrderInfo.PayInfo.WaitPayRecords" :key="i" class="pay-split-item">
            <span>
              第
              <b>{{ OrderInfo.PayInfo.PayRecords.length + i + 1 }}</b>
              次支付金额
            </span>
            <div class="pay-split-item-m">
              <div class="psimp">¥ {{ paid.Amount }}</div>
              <van-button :loading="i == curIndex ? loading : false" @click.stop="goGradePay(paid.Amount, i == OrderInfo.PayInfo.WaitPayRecords.length - 1, i)">
                立即支付
              </van-button>
            </div>
          </div>
        </div>
      </div>
      <!-- 银行列表 -->
      <div v-if="((OrderInfo.PayInfo || {}).CustomerPayModeInfo || {}).IsAllowBankTransfery" class="bank">
        <div class="banktip" style="margin-top: 20px;">
          <van-icon name="info-o" />
          检测到您当前支付金额过大，为避免支付失败，请采用银行转账方式付款：
        </div>
        <div class="banktype"><img src="../../assets/buycar/bank.png"></div>
        <div class="bankinfo">
          <div class="infoitm">
            <div class="left">收款人</div>
            <div class="right">{{ OrderInfo.PayInfo.CustomerPayModeInfo.CompanyBankAccountInfo.Receiver }}</div>
          </div>
          <div class="infoitm">
            <div class="left">收款银行</div>
            <div class="right">{{ OrderInfo.PayInfo.CustomerPayModeInfo.CompanyBankAccountInfo.Bank }}</div>
          </div>
          <div class="infoitm">
            <div class="left">银行信息</div>
            <div class="right">{{ OrderInfo.PayInfo.CustomerPayModeInfo.CompanyBankAccountInfo.BankName }}</div>
          </div>
          <div class="infoitm">
            <div class="left">银行卡号</div>
            <div class="right">{{ OrderInfo.PayInfo.CustomerPayModeInfo.CompanyBankAccountInfo.CardNo }}</div>
          </div>

          <div class="infoitm">
            <div class="left">备注</div>
            <div class="right">只接受公对公转账</div>
          </div>
        </div>
      </div>
      <div v-if="grade == 0" class="btn-submit"><van-button color="#FF3939" :loading="loading" @click.stop="goPay">立即支付</van-button></div>
    </div>
    <!-- 支付对话框 -->
    <van-overlay :show="showPay" z-index="5">
      <div class="paydalog">
        <img class="logo" :src="payWay == 'alipay' ? require('../../assets/buycar/alipaylogo1.png') : require('../../assets/buycar/wxpaylogo1.png')">
        <img class="right_content" :src="payWay == 'alipay' ? require('../../assets/buycar/alipayright.png') : require('../../assets/buycar/wxpayright.png')">
        <img :src="require('../../assets/buycar/alipayimg.png')">
        <div class="change-other-type" @click.stop="changeOtherType">
          <img :src="require('../../assets/buycar/back.png')">
          <span>选择其他支付方式</span>
        </div>
        <div id="payqr" />
        <div v-if="timeout > 0" class="timeout">支付倒计时：{{ getTimeOut() }}</div>
        <div class="tiptxt">
          <img :src="require('../../assets/buycar/scan.png')">
          <div class="txt">
            <span>请使用{{ payWay == 'alipay' ? '支付宝' : '微信' }}扫一扫</span>
            <span>扫描二维码支付</span>
          </div>
        </div>
      </div>
    </van-overlay>
    <iFooter />
  </div>
</template>
<script>
import iHeader from '@/components/Header'
import iFooter from '@/components/Footer'
import iNav from '@/components/Nav'

import { LinkTypeCode } from '../../dictionary/base.js'
import { BaseMixin } from '../../mixins/BaseMixin'
import { Dialog } from 'vant'
import QRCode from 'qrcodejs2'
export default {
  name: 'SelectPay',
  components: { iHeader, iFooter, iNav },
  mixins: [BaseMixin],
  data() {
    return {
      LinkTypeCode,
      payWay: 'alipay', // 支付方式(支付宝，微信，货到付款等)
      grade: '0', // 是否分次支付
      last: true,
      loading: false,

      paying: false,
      showPay: false,

      OrderInfo: {
        OrderId: '',
        OrderNo: '',
        PayMoney: 0,
        PayInfo: {}
      },
      curIndex: null,
      employeeList: [],

      timeout: 0,
      timer: null,

      url: {
        queryPayState: '/api_pay/ExpenseApplications/GetExpenseApplicationState',
        wxpay: '/api_pay/ExpenseApplications/CreatePayWechatPayQrCode',
        alipay: '/api_pay/ExpenseApplications/CreatePayAlipayQrCode',
        // 到付
        waitpay: '/api_pay/ExpenseApplications/CreatePayCashOnDelivery',
        bank: '/api_pay/ExpenseApplications/CreatePayBankTransfery',
        employee: '/api_customers/Customer/GetCustomerEmployee',
        goods: '/api_goods/GoodsSku/RandomGetGoodsList',
        getOrderPayInfo: '/api_pay/ExpenseApplications/GetOrderPayInfo'
      }
    }
  },
  destroyed() {
    clearInterval(this.timer)
    this.timeout = 0
  },
  created() {
    console.log(JSON.stringify(this.$route.params))
    // const { OrderId, OrderNo, PayMoney, PayInfo } = this.$store.getters.ConfirmToPayData;
    const { OrderId, OrderNo, PayMoney, PayInfo } = this.$route.params
    if (!OrderId || !OrderNo || !PayMoney || PayMoney < 0 || !PayInfo) {
      this.$toast({ position: 'bottom', message: '订单数据异常' })
      this.goMine()
      return
    }

    this.OrderInfo.OrderId = OrderId
    this.OrderInfo.OrderNo = OrderNo
    this.OrderInfo.PayMoney = PayMoney
    this.OrderInfo.PayInfo = PayInfo
  },
  mounted() {
    const _this = this
    // 获取业务员信息
    if ((((_this.OrderInfo || {}).PayInfo || {}).CustomerPayModeInfo || {}).IsAllowBankTransfery) {
      _this.getAction(_this.url.employee).then(w => {
        if (w.IsSuccess) {
          _this.employeeList = w.Data
        }
      })
    }
    _this.actionPayInfo(_this)
  },
  methods: {
    onChangePayWay(payway) {
      this.payWay = payway
    },
    goMine() {
      this.$router.push(this.LinkTypeCode.Mine)
    },
    actionPayInfo(_this) {
      const info = _this.OrderInfo.PayInfo || {}
      info.WaitPayRecords = []
      let amountTotal = info.TotalAmountPaidActual - info.TotalAmountPaid
      while (amountTotal > 0) {
        let amount = amountTotal
        if ((info.CustomerPayModeInfo || {}).IsAllowGradePay && info.GradedPayOneTimeAmount && info.GradedPayOneTimeAmount < amount) {
          amount = info.GradedPayOneTimeAmount
        }
        info.WaitPayRecords.push({
          Id: '',
          Amount: amount.toFixed(2),
          Disabled: false,
          Loading: false
        })
        amountTotal = amountTotal - amount
      }
      _this.grade = (info.CustomerPayModeInfo || {}).IsAllowGradePay || info.WaitPayRecords.length > 1 ? '1' : '0'

      if (((_this.OrderInfo.PayInfo || {}).CustomerPayModeInfo || {}).IsAllowBankTransfery) {
        this.payWay = 'bank'
      }
    },
    async loadPayInfo() {
      const _this = this
      _this.$hys.openLoading()
      _this.loading = true
      try {
        const payInfo = await _this.getAction(_this.url.getOrderPayInfo, { id: _this.OrderInfo.OrderId, no: _this.OrderInfo.OrderNo })
        if (payInfo && payInfo.IsSuccess) {
          _this.OrderInfo.PayInfo = payInfo.Data
          _this.actionPayInfo(_this)
        } else {
          if (payInfo.Msg.indexOf('订单已支付完成') > -1) {
            return false
          }
        }
        return true
      } catch (err) {
      } finally {
        _this.loading = false
        _this.$hys.clearLoading()
      }
    },
    // 支付
    async goPay() {
      const _this = this
      if (!_this.payWay) {
        _this.$toast({ position: 'bottom', message: '请选择支付方式' })
        return
      }
      if (_this.payWay == 'waitpay' && !((_this.OrderInfo.PayInfo || {}).CustomerPayModeInfo || {}).IsAllowCashOnDeliveryInfo) {
        _this.$toast({ position: 'bottom', message: '当前订单不支持货到付款' })
        return
      }
      const para = {
        OrderId: _this.OrderInfo.OrderId,
        OrderNo: _this.OrderInfo.OrderNo,
        Amount: _this.OrderInfo.PayMoney
      }
      _this.OrderInfo.PayWay = _this.payWay
      if (!para.OrderId || !para.OrderNo || para.Amount <= 0) {
        _this.$toast({ position: 'bottom', message: '订单支付信息错误' })
        return
      }
      _this.loading = true
      _this.$hys.openLoading()
      const payRes = await _this.postAction(_this.url[_this.payWay], para)
      _this.$hys.clearLoading()
      if (!payRes.IsSuccess) {
        _this.loading = false
        _this.$toast({ position: 'bottom', message: payRes.Msg })
        return
      }
      // 刷新购物车
      _this.$hys.getCartCount(_this, true)
      switch (_this.payWay) {
        case 'wxpay':
        case 'alipay':
          {
            _this.createQrcode(_this.payWay, payRes.Data.codeUrl)
            _this.showPay = true
          }
          break
        case 'waitpay': // 货到付款
          await _this.goPaySuccess(_this)
          return true
        case 'bank': // 银行转账
          await _this.goPaySuccess(_this)
          return true
        default:
          return true
      }

      setTimeout(() => {
        const res = false
        const getData = { id: payRes.Data.ExpenseApplicationId, no: payRes.Data.ExpenseApplicationNo }
        this.paying = true
        this.goPayValidateSuccess(_this, getData, 0, 0)
        return true
      }, 5000)
    },

    createQrcode(payway, url) {
      document.getElementById('payqr').innerHTML = ''
      const qrcode = new QRCode('payqr', {
        width: 299,
        height: 299,
        text: url, // 二维码地址
        src: payway == 'alipay' ? require('../../assets/buycar/alipaylogo.png') : require('../../assets/buycar/wxpaylogo.png') // 二维码中间的图片
      })
      this.timeout = 600
      this.timer = setInterval(() => {
        if (this.timeout > 0) {
          this.timeout--
          return
        }
        clearInterval(this.timer)
        this.showPay = false
        // this.$router.push(this.LinkTypeCode.MyOrder);
      }, 1000)
    },

    // 分次支付
    async goGradePay(money, last, i) {
      this.curIndex = i
      this.last = last
      this.OrderInfo.PayMoney = money
      const res = await this.goPay()
    },

    /**
		 * 验证支付是否成功
		 */
    async goPayValidateSuccess(_this, para, timers, maxtimers = 10) {
      if (!this.paying) return
      const queryRes = await _this.getAction(_this.url.queryPayState, para)
      if (queryRes.IsSuccess && queryRes.Data == 2) {
        this.paying = false
        this.showPay = false
        if (!this.last && this.OrderInfo.PayInfo.WaitPayRecords.length > 1) {
          // 不是最后一笔，重新加载支付数据
          const rst = await _this.loadPayInfo()
          return
        }
        // console.log(this.last, this.OrderInfo.PayInfo.WaitPayRecords.length)

        // if (!rst) {
        await _this.goPaySuccess(_this)
        // } else {
        _this.$hys.clearLoading()
        // }
      } else if (queryRes.IsSuccess && queryRes.Data == 3) {
        // 跳转支付失败
        _this.$hys.clearLoading()
        // this.$router.push({ path: 'PayFail', params: _this.OrderInfo });
      } else if (maxtimers > 0 && timers > maxtimers && _this.payWay != 'bank') {
        _this.OrderInfo.PayWay = 'IsStateNotPay'
        await _this.goPaySuccess(_this)
      } else {
        setTimeout(() => {
          this.goPayValidateSuccess(_this, para, timers + 1, maxtimers)
        }, 3000)
      }
    },
    // 修改支付方式
    async changeOtherType() {
      this.showPay = false
      this.paying = false
      const rst = await this.loadPayInfo() // 重新加载支付数据
      if (!rst) {
        await this.goPaySuccess(_this)
      } else {
        clearInterval(this.timer)
        this.timeout = 0
        this.$hys.clearLoading()
      }
    },
    /**
		 * 跳转支付成功
		 */
    async goPaySuccess(_this) {
      // 获取随机商品信息
      _this.OrderInfo.GoodsList = []
      const glst = await _this.getAction(_this.url.goods)
      _this.loading = false
      _this.$hys.clearLoading()
      if (glst.IsSuccess) {
        _this.OrderInfo.GoodsList = glst.Data
      }
      // 跳转支付成功
      this.$router.push({
        name: LinkTypeCode.PaySuccess,
        params: {
          payWay: this.payWay,
          payMoney: this.OrderInfo.PayInfo.TotalAmountPaidActual,
          orderId: this.OrderInfo.OrderId
        }
      })
    },
    // 支付遇到问题
    onClickRight() {
      this.$router.push(PayQuota)
    },
    getTimeOut() {
      const min = parseInt(this.timeout / 60)
      const sec = parseInt(this.timeout % 60)
      let tim = ''
      if (min > 0) {
        tim = `${tim}${min}分钟`
      }
      tim = `${tim}${sec}秒`
      return tim
    }
  }
}
</script>
<style lang="less">
.select-pay {
  background-color: #F3F5F7;

  a {
    color: #0F6EEA;
  }

  .orderInfo {
    display: flex;
    align-items: center;
    margin: 0 auto;
    margin-top: 30px;
    width: 1200px;
    height: 190px;
    background-color: #FFFFFF;
    box-sizing: border-box;

    img,
    .infotext {
      margin-left: 40px;
    }

    .infotext {
      display: flex;
      justify-content: space-between;
      align-items: center;
      width: calc(1200px - 127px);

      .info {
        text-align: left;

        .line1 {
          font-size: 26px;

          span {
            color: #0F6EEA;
          }
        }

        .line2 {
          margin-top: 10px;
          font-size: 14px;
          color: #777777;

          span {
            color: #FF3939;
          }
        }
      }

      .price {
        margin-right: 30px;
        font-size: 14px;
        color: #222222;

        span {
          font-size: 26px;
          color: #FF3939;
        }
      }
    }
  }

  .payInfo {
    display: flex;
    align-items: center;
    margin: 0 auto;
    margin-top: 30px;
    margin-bottom: 80px;
    padding: 40px 35px 120px 40px;
    width: 1200px;
    background-color: #FFFFFF;
    flex-direction: column;
    box-sizing: border-box;

    .line {
      margin-top: 20px;
      width: 100%;
      height: 1px;
      background-color: #E8E8E8;
    }

    .tip {
      display: flex;
      justify-content: space-between;
      width: 100%;
      font-size: 16px;
      color: #777777;

      span {
        &:first-child {
          font-size: 16px;
          color: #777777;
        }

        &:last-child {
          float: right;
          font-size: 14px;
          color: #0F6EEA;
        }
      }
    }

    .three {
      display: flex;
      align-items: center;
      width: 100%;

      div {
        position: relative;
        display: flex;
        justify-content: center;
        align-items: center;
        margin-top: 50px;
        border: 1px solid rgba(229, 229, 229, 1);
        border-radius: 2px;
        height: 80px;
        text-align: center;
        box-sizing: border-box;
        cursor: pointer;

        > img {
          position: absolute;
          left: 30px;
          height: 42px;
        }

        .check {
          display: none;
        }
      }

      .checked {
        position: relative;
        border: 3px solid rgba(15, 110, 234, 1);
        border-radius: 2px;
        box-shadow: 0 5px 14px 0 rgba(231, 231, 231, 1);

        .check {
          position: absolute;
          right: 0;
          bottom: 0;
          display: block;
          border: none;
          width: 39px;
          height: 39px;
        }
      }

      .alipay {
        width: 251px;
      }

      .wxpay {
        margin-left: 50px;
        width: 283px;
      }

      .firstpay {
        margin-left: 50px;
        width: 334px;
      }
    }

    .splitpay {
      margin-top: 50px;
      width: 100%;
      font-size: 20px;
      color: #222222;

      /deep/.van-radio-group {
        height: 28px;
      }

      /deep/.van-radio--horizontal {
        margin-right: 130px;
      }

      .banklist,
      .morebank {
        display: flex;
        padding: 0 0 20px 20px;
        width: 100%;
        font-size: 14px;
        background-color: #F8F8F8;
        box-sizing: border-box;
        flex-direction: column;
        cursor: pointer;

        .bankitm {
          display: flex;
          align-items: center;
          margin-top: 20px;

          .left {
            max-width: 22px;
            max-height: 22px;
            text-align: left;
          }

          .right {
            margin-left: 10px;
            color: #222222;
          }
        }
      }

      .morebank {
        font-size: 14px;
        text-align: left;
        color: rgba(15, 110, 234, 1);
      }
    }

    .banktip {
      display: flex;
      align-items: center;
      margin-top: 50px;
      padding-left: 20px;
      width: 100%;
      height: 50px;
      font-size: 14px;
      text-align: left;
      color: #E47D2F;
      background-color: #FFF7E9;
      box-sizing: border-box;

      i {
        margin-top: 3px;
        margin-right: 5px;
      }
    }

    .pay-split {
      display: flex;
      align-items: flex-start;
      margin-top: 30px;
      padding-top: 30px;
      padding-bottom: 56px;
      padding-left: 40px;
      background-color: #F8F8F8;
      box-sizing: border-box;
      flex-direction: column;

      .title {
        margin-bottom: 10px;
        font-size: 16px;
        color: #777777;
      }

      .pay-split-item {
        margin-top: 40px;
        text-align: left;

        > span {
          font-size: 20px;
          text-align: left;
          color: #C2C2C2;
        }

        .pay-split-item-m {
          display: flex;
          align-items: center;
          margin-top: 20px;

          button {
            margin-left: 97px;
            width: 258px;
            height: 80px;
            font-size: 26px;
            color: #FFFFFF;
            background-color: #FF3939;

            &:disabled {
              background-color: #D5D5D5;
            }
          }

          .psimpd,
          .psimp {
            border-radius: 4px;
            padding-left: 30px;
            width: 410px;
            height: 80px;
            font-size: 32px;
            color: #777777;
            background-color: #F1F1F1;
            line-height: 80px;
            box-sizing: border-box;
          }
        }
      }
    }

    .bank {
      width: 100%;

      .banktype {
        display: flex;
        justify-content: center;
        align-items: center;
        margin-top: 50px;
        border: 1px solid rgba(229, 229, 229, 1);
        border-radius: 2px;
        width: 296px;
        height: 80px;
        text-align: center;
        box-sizing: border-box;

        img {
          height: 44px;
        }
      }

      .bankinfo {
        display: flex;
        margin-top: 30px;
        padding: 0 0 20px 20px;
        width: 100%;
        font-size: 14px;
        background-color: #F8F8F8;
        box-sizing: border-box;
        flex-direction: column;

        .infoitm {
          display: flex;
          align-items: center;
          margin-top: 20px;

          .left {
            width: 60px;
            text-align: left;
            color: #444444;
          }

          .right {
            margin-left: 50px;
            color: #777777;
          }
        }
      }
    }

    .btn-submit {
      margin-top: 44px;
      width: 100%;
      text-align: left;

      button {
        width: 258px;
        height: 80px;
        font-size: 26px;
      }
    }
  }

  .paydalog {
    position: relative;
    margin: 0 auto;
    margin-top: 150px;
    width: 1200px;
    height: 650px;

    .change-other-type {
      position: absolute;
      bottom: 24px;
      left: 42px;
      display: flex;
      align-items: center;
      width: 140px;
      height: 26px;
      cursor: pointer;

      > span {
        margin-left: 15px;
        font-size: 14px;
        color: #0F6EE9;
      }
    }

    .timeout {
      position: absolute;
      top: 120px;
      left: 201px;
      width: 299px;
      height: 30px;
      font-size: 16px;
      text-align: center;
      color: #FF3939;
      line-height: 30px;
    }

    .tiptxt {
      position: absolute;
      top: 486px;
      left: 205px;
      display: flex;
      align-items: center;
      width: 300px;
      height: 63px;
      background-color: #70AAF4;

      > img {
        margin-left: 17px;
      }

      .txt {
        display: flex;
        justify-content: space-between;
        align-items: flex-start;
        margin-left: 14px;
        font-size: 14px;
        color: #FFFFFF;
        flex-direction: column;
      }
    }

    .logo {
      position: absolute;
      top: 37px;
      left: 30px;
    }

    .right_content {
      position: absolute;
      top: 113px;
      left: 656px;
    }

    #payqr {
      position: absolute;
      top: 166px;
      left: 205px;
      width: 299px;
      height: 299px;
    }
  }

  .carName {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    height: 100%;

    .cn {
      display: flex;
      align-items: flex-end;
      height: 100%;
    }
  }
}
</style>
